import { render, staticRenderFns } from "./AiLaw.vue?vue&type=template&id=003b557a&scoped=true"
import script from "./AiLaw.vue?vue&type=script&lang=js"
export * from "./AiLaw.vue?vue&type=script&lang=js"
import style0 from "./AiLaw.vue?vue&type=style&index=0&id=003b557a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003b557a",
  null
  
)

export default component.exports